export function getDefaultConsoleLogger(name) {
  return {
    debug: function debug(message, data) {
      data = JSON.parse(JSON.stringify(data !== null && data !== void 0 ? data : {}));
      console.debug(new Date().toISOString() + " [DEBUG] [".concat(name, "] ") + message, data);
    },
    info: function info(message, data) {
      data = JSON.parse(JSON.stringify(data !== null && data !== void 0 ? data : {}));
      console.info(new Date().toISOString() + " [INFO]  [".concat(name, "] ") + message, data);
    },
    warn: function warn(message, data) {
      data = JSON.parse(JSON.stringify(data !== null && data !== void 0 ? data : {}));
      console.warn(new Date().toISOString() + " [WARN]  [".concat(name, "] ") + message, data);
    },
    error: function error(message, data) {
      data = JSON.parse(JSON.stringify(data !== null && data !== void 0 ? data : {}));
      console.error(new Date().toISOString() + " [ERROR] [".concat(name, "] ") + message, data);
    }
  };
}